import * as React from 'react';
import { useState } from 'react';
import { Pagination, Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import './style.scss';

import PrevIcon from './icons/prev.inline.svg';
import NextIcon from './icons/next.inline.svg';

const TabbedContent = props => {
  const [swiper, setSwiper] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const paginationRef = React.useRef(null);
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);

  return (
    <div className="tabbed-content">
      <div className="tabs">
        {props.tabs.map((tab, i) => (
          <button
            key={i}
            className={`tab ${activeTabIndex === i ? 'is-active' : ''}`}
            onClick={() => {
              swiper.slideTo(i);
              setActiveTabIndex(i);
            }}
          >
            {tab.title}
          </button>
        ))}
      </div>

      <Swiper
        autoHeight
        modules={[Navigation, Pagination, A11y]}
        navigation={{
          prevEl: navigationPrevRef.current,
          nextEl: navigationNextRef.current,
        }}
        pagination={{
          el: paginationRef.current,
          clickable: true,
        }}
        onSwiper={instance => setSwiper(instance)}
        onSlideChange={swiper => setActiveTabIndex(swiper.activeIndex)}
        onBeforeInit={swiper => {
             swiper.params.navigation.prevEl = navigationPrevRef.current;
             swiper.params.navigation.nextEl = navigationNextRef.current;
             swiper.params.pagination.el = paginationRef.current;
        }}
      >
        {props.tabs.map((tab, i) => (
          <SwiperSlide key={i}>
            <div className={`tab-content ${activeTabIndex === i ? 'is-active' : ''}`}>
              <h5 className="mob-title">{tab.title}</h5>
              {tab.content}
            </div>
          </SwiperSlide>
        ))}

        <div className="swiper-navigation">
          <div role="button" ref={navigationPrevRef} tabIndex={0}>
            <PrevIcon />
            <span className="sr-only">Previous slide</span>
          </div>
          <div ref={paginationRef} className="swiper-pagination" />
          <div role="button" ref={navigationNextRef} tabIndex={0}>
            <NextIcon />
            <span className="sr-only">Next slide</span>
          </div>
        </div>
      </Swiper>
    </div>
  );
};

export default TabbedContent;
